import { render, staticRenderFns } from "./configmap.vue?vue&type=template&id=26c54852&"
import script from "./configmap.vue?vue&type=script&lang=js&"
export * from "./configmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports